import { render, staticRenderFns } from "./AcercaDe.vue?vue&type=template&id=1b9483ce&"
import script from "./AcercaDe.vue?vue&type=script&lang=js&"
export * from "./AcercaDe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports